import { InAppBrowserOptions } from '@ionic-native/in-app-browser';
import { TranslateService } from '@ngx-translate/core';
import { Platform } from 'ionic-angular';
import { APP_CONFIG } from '../../environment';
import { brandings } from '../../environment/branding/brandings';
import { ColorProvider } from '../color/color';

export const WALMART_CLOSE_BUTTON_COLOR = '#0084ff';

/**
 * Default in-app browser options, shared by every IAB the app opens so the copies cannot drift.
 * `location` differs per platform (inappbrowser 7.x): on iOS 'no' only hides the address pill,
 * on Android 'no' drops the whole toolbar, Close button included (OM-21035).
 */
export function buildDefaultIabOptions(platform: Platform, translate: TranslateService): InAppBrowserOptions {
  let location: 'yes' | 'no' = 'yes';
  if (platform.is('ios')) {
    location = 'no';
  }
  let closeButtonColor = WALMART_CLOSE_BUTTON_COLOR;
  if (APP_CONFIG.branding !== brandings.Walmart) {
    closeButtonColor = ColorProvider.getColorValue('--app-primary');
  }
  return {
    hidenavigationbuttons: 'yes',
    toolbarcolor: ColorProvider.getColorValue('--gray-100'),
    toolbartranslucent: 'no', // iOS: solid toolbar, no liquid-glass/see-through bar (inappbrowser 7.x)
    hideurlbar: 'yes', // Android only
    location,
    toolbarposition: 'top',
    closebuttoncaption: translate.instant('global.closeButton'),
    closebuttoncolor: closeButtonColor,
  };
}



// WEBPACK FOOTER //
// ./src/providers/route/iab-options.ts